import { Vue, Component, Prop } from 'vue-property-decorator'
import type { PaymentType } from '../../types';

@Component
export default class DefaultPaymentProp extends Vue {
  @Prop({ required: false, default: false }) defaultPayment!: PaymentType | false;
}
